// import axios from "axios";
// import { POST_AIRA_SPEAKER, POST_CHAT_HISTORY, POST_TYPE_CHAT } from "../../utils/api";
// import {
//   TYPE_CHAT_STREAM_START,
//   TYPE_CHAT_STREAM_UPDATE,
//   TYPE_CHAT_SUCCESS,
//   TYPE_CHAT_FAILURE,
//   TYPE_CHAT_CLEAR,
//   CHAT_HISTORY_ONE_SUCCESS,
//   CHAT_HISTORY_ONE_FAILURE,
//   CHAT_HISTORY_SEVEN_SUCCESS,
//   CHAT_HISTORY_SEVEN_FAILURE,
//   CHAT_HISTORY_MONTH_SUCCESS,
//   CHAT_HISTORY_MONTH_FAILURE,
//   ANSWER_SPEAKER_SUCCESS,
//   ANSWER_SPEAKER_FAILURE,
// } from "./chat.actionTypes";

// export const generateChat = (payload) => async (dispatch) => {
//   const token = localStorage.getItem("access_token") || null;

//   dispatch({ type: TYPE_CHAT_STREAM_START });

//    const formData = new FormData();
//     formData.append("user_query", payload.user_query);
//     formData.append("session_id",payload.session_id);
//     formData.append("history", payload.history);
//    if (payload.imageFile) {
//   formData.append("image_file", payload.imageFile);
// }

//   try {
//     const response = await fetch(POST_TYPE_CHAT, {
//       method: "POST",
//       headers: {
//       Authorization: `Bearer ${token}`,
//         // "Content-Type": "application/json",
//             },
//       credentials: "include",
//       body: formData,
//     });

//     if (!response.ok) throw new Error("Response not OK");

//     const reader = response.body.getReader();
//     const decoder = new TextDecoder();
//     let fullText = "";

//     while (true) {
//       const { value, done } = await reader.read();
//       if (done) break;

//       const decodedChunk = decoder.decode(value, { stream: true });
//       fullText += decodedChunk;

//       dispatch({
//         type: TYPE_CHAT_STREAM_UPDATE,
//         payload: { chunk: decodedChunk },
//       });
//     }

//   let parsedResponse = fullText;
// let updatedHistory = [];
// let parsedQuestion = "";

// try {
//   const parsed = JSON.parse(fullText);

//   parsedResponse = parsed.response || fullText;
//   parsedQuestion = parsed.question || "";
//   updatedHistory = parsed.messages || [];   // ✅ correct key
//   localStorage.setItem("session_id", parsed.session_id);

// } catch (e) {
//   console.warn("Failed to parse JSON:", e);
// }

// dispatch({
//   type: TYPE_CHAT_SUCCESS,
//   payload: {
//     data: parsedResponse,
//     history: updatedHistory,   // will now contain messages array
//     questionData: parsedQuestion,
//   },
// });

//     return { success: true };
//   } catch (error) {
//     const errMsg = error?.message || "Something went wrong";

//     dispatch({
//       type: TYPE_CHAT_FAILURE,
//       payload: { message: errMsg },
//     });

//     return { success: false, message: errMsg };
//   }
// };

// export const clearChat = () => ({
//   type: TYPE_CHAT_CLEAR,
// });

// export const chatHistoryOneDay = (day) => async (dispatch) => {
//   const token = localStorage.getItem("access_token") || null;
//   const headers = {
//     Authorization: `Bearer ${token}`,
//   };
//   try {
//     const resp = await axios.get(`${POST_CHAT_HISTORY}?days=${day}`, {
//       headers,
//       withCredentials: true,
//     });
//     if (resp.status === 200) {
//       dispatch({
//         type: CHAT_HISTORY_ONE_SUCCESS,
//         payload: { data: resp.data },
//       });
//       return { success: true };
//     } else {
//       dispatch({
//         type: CHAT_HISTORY_ONE_FAILURE,
//         payload: { message: resp?.data },
//       });
//       return { success: false, message: resp?.data };
//     }
//   } catch (error) {
//     const errorMsg = error?.response?.data?.detail || "Something went wrong";
//     dispatch({
//       type: CHAT_HISTORY_ONE_FAILURE,
//       payload: { message: errorMsg },
//     });
//     return { success: false, message: errorMsg };
//   }
// };

// export const chatHistorySevenDay = (day) => async (dispatch) => {
//   const token = localStorage.getItem("access_token") || null;
//   const headers = {
//     Authorization: `Bearer ${token}`,
//   };
//   try {
//     const resp = await axios.get(`${POST_CHAT_HISTORY}?days=${day}`, {
//       headers,
//       withCredentials: true,
//     });
//     if (resp.status === 200) {
//       dispatch({
//         type: CHAT_HISTORY_SEVEN_SUCCESS,
//         payload: { data: resp.data },
//       });
//       return { success: true };
//     } else {
//       dispatch({
//         type: CHAT_HISTORY_SEVEN_FAILURE,
//         payload: { message: resp?.data },
//       });
//       return { success: false, message: resp?.data };
//     }
//   } catch (error) {
//     const errorMsg = error?.response?.data?.detail || "Something went wrong";
//     dispatch({
//       type: CHAT_HISTORY_SEVEN_FAILURE,
//       payload: { message: errorMsg },
//     });
//     return { success: false, message: errorMsg };
//   }
// };

// export const chatHistoryOneMonth = (day) => async (dispatch) => {
//   const token = localStorage.getItem("access_token") || null;
//   const headers = {
//     Authorization: `Bearer ${token}`,
//   };
//   try {
//     const resp = await axios.get(`${POST_CHAT_HISTORY}?days=${day}`, {
//       headers,
//       withCredentials: true,
//     });
//     if (resp.status === 200) {
//       dispatch({
//         type: CHAT_HISTORY_MONTH_SUCCESS,
//         payload: { data: resp.data },
//       });
//       return { success: true };
//     } else {
//       dispatch({
//         type: CHAT_HISTORY_MONTH_FAILURE,
//         payload: { message: resp?.data },
//       });
//       return { success: false, message: resp?.data };
//     }
//   } catch (error) {
//     const errorMsg = error?.response?.data?.detail || "Something went wrong";
//     dispatch({
//       type: CHAT_HISTORY_MONTH_FAILURE,
//       payload: { message: errorMsg },
//     });
//     return { success: false, message: errorMsg };
//   }
// };


import { apiRequest } from "../../api/apiRequest";
import { POST_AIRA_SPEAKER, POST_CHAT_HISTORY, POST_TYPE_CHAT } from "../../utils/api";
import {
  TYPE_CHAT_STREAM_START,
  TYPE_CHAT_STREAM_UPDATE,
  TYPE_CHAT_SUCCESS,
  TYPE_CHAT_FAILURE,
  TYPE_CHAT_CLEAR,
  CHAT_HISTORY_ONE_SUCCESS,
  CHAT_HISTORY_ONE_FAILURE,
  CHAT_HISTORY_SEVEN_SUCCESS,
  CHAT_HISTORY_SEVEN_FAILURE,
  CHAT_HISTORY_MONTH_SUCCESS,
  CHAT_HISTORY_MONTH_FAILURE,
  ANSWER_SPEAKER_SUCCESS,
  ANSWER_SPEAKER_FAILURE,
} from "./chat.actionTypes";

export const generateChat = (payload) => async (dispatch) => {
  const token = localStorage.getItem("access_token") || null;

  dispatch({ type: TYPE_CHAT_STREAM_START });

  const formData = new FormData();
  formData.append("user_query", payload.user_query);
  formData.append("session_id", payload.session_id);
  formData.append("history", payload.history);
  if (payload.imageFile) {
    formData.append("image_file", payload.imageFile);
  }

  try {
    const response = await fetch(POST_TYPE_CHAT, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        // "Content-Type": "application/json",
      },
      credentials: "include",
      body: formData,
    });

    if (!response.ok) throw new Error("Response not OK");

    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let fullText = "";

    while (true) {
      const { value, done } = await reader.read();
      if (done) break;

      const decodedChunk = decoder.decode(value, { stream: true });
      fullText += decodedChunk;

      dispatch({
        type: TYPE_CHAT_STREAM_UPDATE,
        payload: { chunk: decodedChunk },
      });
    }

    let parsedResponse = fullText;
    let updatedHistory = [];
    let parsedQuestion = "";

    try {
      const parsed = JSON.parse(fullText);

      parsedResponse = parsed.response || fullText;
      parsedQuestion = parsed.question || "";
      updatedHistory = parsed.messages || []; // ✅ correct key
      localStorage.setItem("session_id", parsed.session_id);
    } catch (e) {
      console.warn("Failed to parse JSON:", e);
    }

    dispatch({
      type: TYPE_CHAT_SUCCESS,
      payload: {
        data: parsedResponse,
        history: updatedHistory, // will now contain messages array
        questionData: parsedQuestion,
      },
    });

    return { success: true };
  } catch (error) {
    const errMsg = error?.message || "Something went wrong";

    dispatch({
      type: TYPE_CHAT_FAILURE,
      payload: { message: errMsg },
    });

    return { success: false, message: errMsg };
  }
};

export const clearChat = () => ({
  type: TYPE_CHAT_CLEAR,
});

export const chatHistoryOneDay = (day) => async (dispatch) => {
  const result = await apiRequest("get", `${POST_CHAT_HISTORY}?days=${day}`);

  if (result.success) {
    dispatch({
      type: CHAT_HISTORY_ONE_SUCCESS,
      payload: { data: result.data },
    });
    return { success: true };
  }

  dispatch({
    type: CHAT_HISTORY_ONE_FAILURE,
    payload: { message: result.message },
  });
  return { success: false, message: result.message };
};

export const chatHistorySevenDay = (day) => async (dispatch) => {
  const result = await apiRequest("get", `${POST_CHAT_HISTORY}?days=${day}`);

  if (result.success) {
    dispatch({
      type: CHAT_HISTORY_SEVEN_SUCCESS,
      payload: { data: result.data },
    });
    return { success: true };
  }

  dispatch({
    type: CHAT_HISTORY_SEVEN_FAILURE,
    payload: { message: result.message },
  });
  return { success: false, message: result.message };
};

export const chatHistoryOneMonth = (day) => async (dispatch) => {
  const result = await apiRequest("get", `${POST_CHAT_HISTORY}?days=${day}`);

  if (result.success) {
    dispatch({
      type: CHAT_HISTORY_MONTH_SUCCESS,
      payload: { data: result.data },
    });
    return { success: true };
  }

  dispatch({
    type: CHAT_HISTORY_MONTH_FAILURE,
    payload: { message: result.message },
  });
  return { success: false, message: result.message };
};